// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3ePSl","buttons":"PendingPaymentAlert_buttons__33E5Q"};